// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1zmIz","icon":"SortAdornment_icon__2o-tU","up":"SortAdornment_up__2ELQw","down":"SortAdornment_down__2dqLn","active":"SortAdornment_active__1hRwE"};